/**
 * Motion: one subtle, fast setting for list and grid reflows, through
 * @formkit/auto-animate. It respects prefers-reduced-motion on its own.
 * Duration is read from the --motion-base token so it stays centralised.
 */
import { useAutoAnimate } from '@formkit/auto-animate/react'

function motionBaseMs(): number {
  if (typeof window === 'undefined') return 180
  const raw = getComputedStyle(document.documentElement).getPropertyValue('--motion-base').trim()
  const parsed = Number.parseFloat(raw)
  return Number.isFinite(parsed) ? parsed : 180
}

/** Attach the returned ref to any list or grid container; children animate on add, remove and reorder. */
export function useListMotion<T extends HTMLElement>() {
  return useAutoAnimate<T>({ duration: motionBaseMs(), easing: 'cubic-bezier(.2,.7,.2,1)' })
}
